import { lazy } from 'react';
import CleanLayout from '../layout/CleanLayout';
import Loadable from '../ui-component/Loadable';

const ConfirmRequest = Loadable(lazy(() => import('../views/pages/ConfirmRequest')));
const RequestServicePage = Loadable(lazy(() => import('../views/organizationUserViews/requestService')));

const RoutesWithoutAuthorization = {
    path: '/',
    element: <CleanLayout />,
    // element: <EmptyLayout />,
    children: [
        {
            path: '/confirm',
            element: <ConfirmRequest />
        },
        {
            path: '/pateikti-uzklausa',
            element: <RequestServicePage />
        }
    ]
};

export default RoutesWithoutAuthorization;